import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECTS',
  name: 'Workspace Projects',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  fields: [
    { key: 'name', title: 'Name' },
    { key: 'status', title: 'Status' },
    { key: 'state', title: 'State' },
    { key: 'type', title: 'Type' },
    { key: 'description', title: 'Description' },
    { key: 'icon', title: 'Icon' },
    { key: 'projectDates', title: 'Project Dates' },
    { key: 'metric', title: 'Metric' },
    { key: 'dataset', title: 'Dataset' },
    { key: 'story', title: 'Story' },
    { key: 'playground', title: 'Playground' },
    { key: 'mapView', title: 'Map View' },
    { key: 'createdAt', title: 'Date created' },
    { key: 'updatedAt', title: 'Date updated' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY', 'RESTORE'],
}

export default scope
